import Router from "./router/Router";
import "./styles/layout.css";

function App() {
  return <Router />;
}

export default App;
